// umlaut-check: skip — "TabellenUeberlaufSchatten"/"useTabellenUeberlauf"
// sind Komponenten-/Funktionsnamen (technische Bezeichner), bleiben ASCII.

import React, {useEffect, useState} from "react";

/**
 * Erkennt, ob ein Container (typischerweise eine waagerecht scrollbare
 * Tabelle) breiter ist als sein sichtbarer Rahmen (Befund N2, Rückmeldung
 * 22.09.2026: die letzte Spalte von Lieferplan und Lieferungen wirkte bei
 * 1440 px abgeschnitten). Reagiert auf Größenänderungen des Containers und
 * des Fensters (mehr/weniger Wochen- bzw. Spalten können die Breite
 * ändern, ohne dass sich `deps` ändert).
 *
 * @param {React.RefObject<HTMLElement>} containerRef
 * @param {Array<unknown>} [deps] - zusätzliche Auslöser für eine Neuprüfung
 *   (z. B. Spaltenanzahl), falls sich der Inhalt ändert, ohne dass
 *   ResizeObserver selbst anschlägt.
 */
export function useTabellenUeberlauf(containerRef, deps = []) {
    const [ueberlauf, setUeberlauf] = useState(false);

    useEffect(() => {
        const el = containerRef.current;
        if (!el || typeof ResizeObserver === "undefined") {
            return undefined;
        }
        const pruefen = () => setUeberlauf(el.scrollWidth > el.clientWidth + 1);
        pruefen();
        const beobachter = new ResizeObserver(pruefen);
        beobachter.observe(el);
        return () => beobachter.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return ueberlauf;
}

/**
 * Rein optischer Farbverlauf am rechten Rand, der anzeigt "hier geht es
 * waagerecht weiter" - notwendig, weil `overflow-x: auto` allein in Ruhe
 * keinen Hinweis zeigt, sobald das Betriebssystem Scrollbalken nur
 * während des Scrollens einblendet (macOS-Standard): die letzte Spalte
 * wirkt dann wie abgeschnitten statt scrollbar.
 *
 * Erwartet einen Elternrahmen mit `position: relative` um den scrollenden
 * Container - der Schatten selbst liegt AUSSERHALB des Scrollbereichs
 * (overlagert ihn nur optisch) und beeinflusst dessen Breite nicht.
 */
export default function TabellenUeberlaufSchatten({sichtbar}) {
    if (!sichtbar) {
        return null;
    }

    return (
        <div
            aria-hidden="true"
            style={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                width: 28,
                pointerEvents: "none",
                background: "linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.92))",
            }}
        />
    );
}
